if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
  return [
    ...Array.from(this.querySelectorAll('select')).map(
      (select) => select.selectedOptions[0]?.dataset.optionValueId
    ),
    ...Array.from(this.querySelectorAll('fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    ),
  ].filter(Boolean);
}

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] || target : target;
      }

      connectedCallback() {
        if (this.dataset.listenerAttached) return;
        this.dataset.listenerAttached = 'true';

        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          if (!window.FoxTheme?.pubsub) return;

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;
        const selectedValueLabel = target
          .closest('.product-form__input')
          ?.querySelector('[data-selected-swatch-value]');

        if (selectedValueLabel) {
          selectedValueLabel.textContent = value;
        }

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.hasAttribute('selected'))
            ?.removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            ?.querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest('.product-form__input')?.querySelector('[data-selected-value]');

          if (selectedSwatchValue) {
            selectedSwatchValue.textContent = value;
          }
        }
      }
    }
  );
}